import { $http } from "@/utils/http";
import {
    SET_PRODUCTS_LIST,
    SET_LOADING_PRODUCTS_LIST,
    SET_PRODUCTS_ITEM,
    SET_LOADING_PRODUCTS_ITEM,
    SET_LIST_LENGTH,
    CHANGE_SKIP,
    CHANGE_CATEGORY,
    CHANGE_SKIP_TOP_LIST,
} from "../mutation-types";

import { GET_PRODUCTS_LIST, GET_PRODUCTS_ITEM, GET_PRODUCTS_TOP_LIST } from "../action-types";

const state = {
    list: null,
    listLoading: false,
    item: null,
    itemLoading: false,
    skip: 5,
    limit: 5,
    listLength: 0,
    activeCategory: "",
    reviewListLoading: false,
    page: 1,
    topLimit: 10,
};

const getters = {
    list: state => state.list,
    listLoading: state => state.listLoading,
    item: state => state.item,
    itemLoading: state => state.itemLoading,
    skip: state => state.skip,
    limit: state => state.limit,
    listLength: state => state.listLength,
    activeCategory: state => state.activeCategory,
    reviewListLoading: state => state.reviewListLoading,
};

const actions = {
    [GET_PRODUCTS_LIST]: async ({ commit }) => {
        commit(SET_LOADING_PRODUCTS_LIST, true);
        try {
            commit(CHANGE_SKIP);
            const response = await $http.get(
                `v1/top-products-by-category?per-page=${state.skip}&sort=${state.activeCategory}`
            );
            commit(SET_PRODUCTS_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_PRODUCTS_LIST, false);
        }
    },
    [GET_PRODUCTS_TOP_LIST]: async ({ commit }) => {
        commit(SET_LOADING_PRODUCTS_LIST, true);
        try {
            // commit(CHANGE_SKIP_TOP_LIST);
            `v1/products?per-page=${state.limit}&page=${state.page}`;
            const response = await $http.get(
                `v1/top-products-by-category?per-page=${state.topLimit}&page=${state.page}&sort=${state.activeCategory}`
            );
            commit(SET_PRODUCTS_LIST, response.data.data);
            commit(SET_LIST_LENGTH, Math.round(response.data.meta.total / 6) * 6);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_PRODUCTS_LIST, false);
        }
    },
    [GET_PRODUCTS_ITEM]: async ({ commit }, payload) => {
        commit(SET_LOADING_PRODUCTS_ITEM, true);
        try {
            const response = await $http.get(`v1/articles/${payload.id}`);
            commit(SET_PRODUCTS_ITEM, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_PRODUCTS_ITEM, false);
        }
    },
};

const mutations = {
    [SET_PRODUCTS_LIST](state, list) {
        state.list = list;
    },
    [SET_LOADING_PRODUCTS_LIST](state, status) {
        state.listLoading = status;
    },
    [SET_PRODUCTS_ITEM](state, data) {
        state.item = null;
        state.item = data;
    },
    [SET_LOADING_PRODUCTS_ITEM](state, status) {
        state.itemLoading = status;
    },
    [SET_LIST_LENGTH](state, data) {
        state.listLength = data;
    },
    [CHANGE_SKIP](state) {
        state.skip += state.limit;
    },
    [CHANGE_SKIP_TOP_LIST](state, page) {
        state.page = page;
    },
    [CHANGE_CATEGORY](state, category) {
        state.activeCategory = category;
        state.skip = 5;
        state.listLength = 0;
        state.list = null;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
